import React, { useState } from "react";
import styles from "./UsersPage.module.css";
import Header from "DreamStream/Shared/Header";
import TabBar from "DreamStream/Shared/TabBar";
import UsersAllTab from "./UsersAllTab";
import UsersSyncErrorsTab from "./UsersSyncErrorsTab";
import UsersPendingTab from "./UsersPendingTab";

export function UsersPage() {
  const [currentPage, changeCurrentPage] = useState("All Users");

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Header title="USERS" />
      </div>
      <div className={styles.tabBar}>
        <TabBar
          activeTitle={currentPage}
          titleList={["All Users", "Pending", "Sync Errors"]}
          onChange={changeCurrentPage}
        />
      </div>
      <div className={styles.usersContainer}>
        {currentPage === "All Users" ? (
          <UsersAllTab />
        ) : currentPage === "Pending" ? (
          <UsersPendingTab />
        ) : currentPage === "Sync Errors" ? (
          <UsersSyncErrorsTab />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
